import { connect } from 'react-redux'
import TransformManagerComponent from "../components/TransformManagerComponent";
import { moveUpdate, updateTransformStatus, resizeUpdate, rotationUpdate, updateTextStatus, cropImage, toggleCrop, toggleFrame, updateObjectById, updateSelectionBox, setCurrentPosition ,setIsTextClicked} from '../actions/index';
const mapStateToProps = (state, ownProps) => ({
    selectedScene        : state.localStore.get("selectedScene"),
    selectedItems        : state.localStore.get("selectedItems"),
    selectedCamera       : state.localStore.get("selectedCamera"),
    workspaceWidth       : state.project.get("width"),
    workspaceHeight      : state.project.get("height"),

    unSelectedObjects    : (state.localStore.get("selectedItems").size>0)?state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems"]).filter(function(obj, key){return state.localStore.get("selectedItems").keyOf(key) === undefined;}):(state.localStore.get("selectedCamera") !== "")?state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems"]):null,
    selectedChildren     : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceChildren"]),

    unSelectedCameras    : (state.localStore.get("selectedCamera") !== "")?state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceCameras"]).filter(function(obj, key){return state.localStore.get("selectedCamera") !== key;}):null,

    zoomFactor           : state.localStore.get("zoomFactor"),
    playHeadValue        : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "playHeadValue"]),
    currentPosition      : state.localStore.get("currentPosition"),
    textStatus           : state.localStore.get("textStatus"),
    isCropping           : state.localStore.get("isCropping"),
    isFraming            : state.localStore.get("isFraming"),
    workspaceGrid        : state.localStore.get("workspaceGrid"),
    transformStatus      : state.localStore.get("transformStatus"),
    isWorkspaceTextFocus : state.localStore.get('isWorkspaceTextFocus'),
    animakerType         : state.localStore.get('animakerType'),
    isToolCropping       : state.localStore.get('isToolCropping'),
    textOffset           : state.localStore.get('textOffset'),
    isTextClicked    : state.localStore.get("isTextClicked")
          
})
       
const mapDispatchToProps = (dispatch, ownProps) => ({
    moveUpdate:(data,socket) => {dispatch(moveUpdate(data,socket))},
    resizeUpdate:(data,socket) => {dispatch(resizeUpdate(data,socket))},
    rotationUpdate:(data,socket) => {dispatch(rotationUpdate(data,socket))},
    updateTransformStatus:(data) => {dispatch(updateTransformStatus(data))},
    updateTextStatus:(data) => {dispatch(updateTextStatus(data))},
    setCurrentPosition:(data) => {dispatch(setCurrentPosition(data))},
    cropImage:(data, socket) => {
      dispatch(cropImage(data, socket))
    },
    toggleCrop:(data) => {
      dispatch(toggleCrop(data))
    },
    toggleFrame:(data) => {
      dispatch(toggleFrame(data))
    },
    updateObjectById : (data, socket) => {
      dispatch(updateObjectById(data, socket))
    },
    updateItem : (data, socket) => {
      dispatch({type : "UPDATE_ITEM", data : data, socket : socket})
    },
    updateSelectionBox : (data) => {
      dispatch(updateSelectionBox(data))
    },
    updateBg : (data, socket) => {dispatch({type : 'UPDATE_BG', data, socket})},
    setIsTextClicked: (data) => {
      dispatch(setIsTextClicked(data))
    }
})

const TransformManager = connect(mapStateToProps,mapDispatchToProps)(TransformManagerComponent)

export default TransformManager







// WEBPACK FOOTER //
// ./src/containers/TransformManager.js